import React from 'react';
import { Check, ExternalLink } from 'lucide-react';
export function PricingPreview() {
  const packages = [{
    name: 'Bronze',
    title: 'One-Year Repair Service',
    subtitle: '1 Appliance',
    price: '£99',
    features: ['12 months of engineer callouts', 'Labour included for repairs', 'Standard parts when available', 'UK-based support'],
    paymentLink: 'https://buy.stripe.com/your-bronze-link'
  }, {
    name: 'Silver',
    title: 'One-Year Repair Service',
    subtitle: 'TV + Set-Top Box',
    price: '£120',
    features: ['Fast response for TV faults', 'Connection diagnostics', 'Prompt engineer visits', '12 months of service'],
    paymentLink: 'https://buy.stripe.com/your-silver-link',
    featured: true
  }, {
    name: 'Gold',
    title: 'Two-Year Repair Service',
    subtitle: '1 Appliance',
    price: '£150',
    features: ['Extended 24-month support', 'Diagnostics and repairs', 'Priority booking', 'Dedicated support line'],
    paymentLink: 'https://buy.stripe.com/your-gold-link'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4" data-id="element-281">
        <div className="text-center mb-12" data-id="element-282">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-283">
            Service Packages
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-284">
            Choose the package that fits your needs. All include professional
            diagnostics and repairs.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-285">
          {packages.map((pkg, index) => <div key={index} className={`bg-white rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-105 ${pkg.featured ? 'ring-2 ring-[#E8956B]' : ''}`} data-id="element-286">
              {pkg.featured && <div className="bg-[#E8956B] text-white text-center py-2 font-semibold text-sm" data-id="element-287">
                  MOST POPULAR
                </div>}
              <div className="p-8" data-id="element-288">
                <div className="text-center mb-6" data-id="element-289">
                  <div className="inline-block bg-[#0D7377] bg-opacity-10 px-4 py-1 rounded-full mb-4" data-id="element-290">
                    <span className="text-[#0D7377] font-bold text-sm" data-id="element-291">
                      {pkg.name}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-292">
                    {pkg.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4" data-id="element-293">{pkg.subtitle}</p>
                  <div className="mb-6" data-id="element-294">
                    <span className="text-5xl font-bold text-[#0D7377]" data-id="element-295">
                      {pkg.price}
                    </span>
                  </div>
                </div>
                <ul className="space-y-3 mb-8" data-id="element-296">
                  {pkg.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-2" data-id="element-297">
                      <Check className="text-[#8FB996] flex-shrink-0 mt-0.5" size={20} data-id="element-298" />
                      <span className="text-gray-700 text-sm" data-id="element-299">{feature}</span>
                    </li>)}
                </ul>
                <a href={pkg.paymentLink} target="_blank" rel="noopener noreferrer" className={`block w-full text-center px-6 py-4 rounded-lg font-semibold transition-colors shadow-md hover:shadow-lg flex items-center justify-center gap-2 ${pkg.featured ? 'bg-[#E8956B] text-white hover:bg-[#D67D54]' : 'bg-[#0D7377] text-white hover:bg-[#14919B]'}`} data-id="element-300">
                  <ExternalLink size={20} data-id="element-301" />
                  Buy Now
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}